import { Switch } from 'antd';
import { BaseRecord } from 'types';

interface SwitchCommonProps<T extends BaseRecord<unknown>> {
  label: string;
  isActive: boolean;
  onToggle?: (checked: boolean, record: T) => void;
  onChange?: (checked: boolean) => void;
  record?: T;
  disabled?: boolean;
}

const SwitchCommon = <T extends BaseRecord<unknown>>({
  label,
  isActive,
  onToggle,
  onChange,
  record,
  disabled = false,
}: SwitchCommonProps<T>) => {
  const handleChange = (checked: boolean) => {
    if (onChange) {
      onChange(checked);
    } else if (onToggle && record) {
      onToggle(checked, record);
    }
  };

  return (
    <div className='flex items-center gap-3'>
      <Switch
        checked={isActive}
        onChange={handleChange}
        className={isActive ? 'custom-switch custom-switch-active' : 'custom-switch'}
        disabled={disabled}
      />
      <span className='text-black text-[14px] leading-[22px]'>{label}</span>
    </div>
  );
};

export default SwitchCommon;
